/*
 * Public API Surface of ngx-scrollbar
 */

export * from './lib/ng-scrollbar.module';
export * from './lib/ng-scrollbar.model';
export * from './lib/ng-scrollbar';
export * from './lib/scroll-viewport';
export * from './lib/utils/scrollbar-manager';
